import { useSeo } from "@/lib/seo";
import { PageHero } from "@/components/common/PageHero";
import { Section } from "@/components/common/Section";
import { Reveal } from "@/components/common/Reveal";

// Shared layout for legal / policy pages.
export const LegalLayout = ({ eyebrow = "Legal", title, path, seoTitle, seoDescription, sections, intro, lastUpdated }) => {
  useSeo({ title: seoTitle, description: seoDescription, path });
  return (
    <>
      <PageHero eyebrow={eyebrow} titleLines={[title]} lead={intro} />
      <Section className="bg-legacy-charcoal">
        <div className="max-w-3xl space-y-10">
          {lastUpdated && (
            <p className="text-sm uppercase tracking-[0.18em] text-legacy-mint" data-testid="legal-last-updated">
              Last Updated: {lastUpdated}
            </p>
          )}
          {sections.map((s, i) => (
            <Reveal key={i} delay={i * 0.03}>
              <div>
                <h2 className="font-heading text-2xl md:text-3xl text-white">{s.heading}</h2>
                {s.body.map((p, j) => (
                  <p key={j} className="mt-4 text-white/65 leading-relaxed">
                    {p}
                  </p>
                ))}
                {s.list && (
                  <ul className="mt-4 space-y-2 text-white/65">
                    {s.list.map((li, k) => (
                      <li key={k} className="flex items-start gap-3">
                        <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-legacy-mint" aria-hidden="true" />
                        <span>{li}</span>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </Section>
    </>
  );
};
